import styled from '@emotion/styled'

import Row from 'modules/ui/atoms/Layout/Row'
import Column from 'modules/ui/atoms/Layout/Column'

import nationalities from 'i18n-nationality'
import enNationalities from 'i18n-nationality/langs/en.json'

import { getBodyFonts, DEFAULT_THEME_COLORS } from 'css/theme'

import useConfig from 'modules/config/state/use-config'
import useOrder from 'modules/order/state/order/use-order'

const CurrencyDisclaimerContainer = styled.div(() => {
  return {
    padding: '0px',
    margin: 0,
    marginTop: '12px',
    border: `0px`,
    borderRadius: DEFAULT_THEME_COLORS['--theme--border-radius-md'],
    backgroundColor: `${DEFAULT_THEME_COLORS['--theme-color--neutral-100']} !important`,
    gap: '8px',
  }
})

export const CurrencyDisclaimer = () => {
  nationalities.registerLocale(enNationalities)

  const config = useConfig()
  const order = useOrder()

  if (config.currency.default === order.currency.value) return null

  const orgCountry = config.organization.country
  const nationality = nationalities.getName(orgCountry || 'US', 'en')

  // Precompute `a` or `an` for interpolation
  const aOrAnNationality = 'aeiou'.includes(nationality.charAt(0).toLowerCase()) ? 'an' : 'a'

  return (
    <CurrencyDisclaimerContainer data-testid="currencyDisclaimer">
      <Row>
        <Column>
          <span
            style={{
              ...getBodyFonts('sm'),
              color: DEFAULT_THEME_COLORS['--theme-color--neutral-20'],
            }}
          >
            Your donation to {aOrAnNationality} {nationality} organization will be processed in{' '}
            {config.currency.default} and deposited into {aOrAnNationality} {nationality} bank
            account. Tax deductibility depends on your country&apos;s laws. Please consult your
            local tax professional.
          </span>
        </Column>
      </Row>
    </CurrencyDisclaimerContainer>
  )
}
